module.exports = __webpack_public_path__ + "img/3bd898b8f703ab7325d94122190c7fec.png";